import { RefreshRounded } from "@mui/icons-material";
import { IconButton, SxProps } from "@mui/material";

import Spinner from "./Spinner";

const Refresh = ({
  sx = { m: 1.5 },
  onClick,
  isFetching = false,
}: {
  sx?: SxProps;
  onClick: () => void;
  isFetching: boolean;
}) =>
  isFetching ? (
    <Spinner sx={sx} />
  ) : (
    <IconButton aria-label="refresh" onClick={onClick}>
      <RefreshRounded />
    </IconButton>
  );
export default Refresh;
